var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "465pt",
    viewBox: "-2 0 465 465.31782",
    width: "465pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.160156 120h48v144h-48zm0 0",
    fill: "#2d75bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48.160156 136h32v112h-32zm0 0",
    fill: "#50b3c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m272.160156 272h96v32h-96zm0 0",
    fill: "#50b3c9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m272.160156 160h-24l-16-32h-96l-16 32h-40v64h176c17.671875 0 32 14.328125 32 32v16h64v-32c0-44.183594-35.820312-80-80-80zm0 0",
    fill: "#86d5e2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m118.585938 167.84375 3.136718-15.691406 40 8-3.136718 15.691406zm0 0",
    fill: "#cdeef6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m206.636719 160.3125 40.019531-7.992188 3.136719 15.695313-40.019531 7.996094zm0 0",
    fill: "#cdeef6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m152.160156 96h64v32h-64zm0 0",
    fill: "#2d75bb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m168.160156 64h32v32h-32zm0 0",
    fill: "#195c85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m96.160156 32h176v32h-176zm0 0",
    fill: "#dd3e46"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m184.160156 0c8.835938 0 16 7.164062 16 16v16h-32v-16c0-8.835938 7.164063-16 16-16zm0 0",
    fill: "#fcf05a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m128.160156 32h16v32h-16zm0 0",
    fill: "#b11e48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m176.160156 32h16v32h-16zm0 0",
    fill: "#b11e48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m224.160156 32h16v32h-16zm0 0",
    fill: "#b11e48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m376.160156 464h-112l24-160h64zm0 0",
    fill: "#cdeef6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m288.261719 462.683594 16.015625-96 15.785156 2.632812-16.019531 96zm0 0",
    fill: "#86d5e2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m328.207031 392.878906 15.902344-1.765625 8 71.996094-15.902344 1.769531zm0 0",
    fill: "#86d5e2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m408.160156 432s-4.378906-38.976562 16-64c20.375-25.023438 58.398438 10.113281 24 32-34.402344 21.886719-40 32-40 32zm0 0",
    fill: "#cdeef6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m232.160156 448s1.808594-52.648438-24-72c-32-24-60.105468 20.992188-24 40 36.101563 19.007812 48 32 48 32zm0 0",
    fill: "#cdeef6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2d75bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.160156 360h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.160156 336h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.160156 312h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.160156 272h16v16h-16zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.3e155915d486394c1fb5b0d68d2afe6e.svg";
export { ForwardRef as ReactComponent };